export default "__VITE_ASSET__ef5f83b5__"